import { jsx as _jsx } from "react/jsx-runtime";
import DocaposteSection from "./DocaposteSection";
const DocaposteSectionPreview = () => {
    return _jsx(DocaposteSection, { surtitle: "Blog", title: "Nos derniers articles" });
};
export default DocaposteSectionPreview;
